import tw from 'twin.macro';

export const h1Style = tw`text-3xl font-bold font-heading leading-9`;
export const h2Style = tw`text-2xl font-bold`;
export const h3Style = tw`text-xl font-bold leading-6`;
export const h4Style = tw`font-bold text-lg`;
export const h5Style = tw`font-bold text-base`;
